export const ExtensionType = {
  SCHEDULE_ENEOS_KAWASAKI: 1, // 予定表（JXTG川崎）画面
  SCHEDULE_ENEOS_CHITA: 2, // 予定表（JXTG知多）画面
  SCHEDULE_ENEOS_NEGISHI: 3, // 予定表（JXTG根岸）出力機能
  SCHEDULE_IDEMITSU_TOKUYAMA: 4, // 予定表（出光徳山）出力機能
  FILE_UPLOAD: 5, // ファイルアップロード機能制御
  SCHEDULE_OIREC_CHIBA: 6, // 予定表（ENEOS OIREC千葉）画面
  SCHEDULE_IDEMITSU_CHIBA: 7, // 予定表（出光千葉）出力機能
  TWO_FACTOR_AUTHENTICATION: 8, // 2段階認証を行う
  PROGRESS_LINE_COLUMN_LENGTH: 9, // イナズマ線図の作業名当たり判定調整
  SCHEDULE_OPC_OSAKA: 10, // 予定表（OPC大阪）出力機能
  SCHEDULE_MITSUI_IWAKUNI: 11, // 予定表（三井岩国）出力機能
  TASK_LINKAGE: 12, // 作業項目連携を行う
  MACHINE_REQUEST_FORM: 13, // 重機：重機依頼書の出力機能
  MATRIX_SCHEDULE_STYLING: 14, // 明細セルの日付表示を詳細化
  SCHEDULE_COSMO_CHIBA: 16, // 予定表（コスモ千葉）出力機能
  SCHEDULE: 17, // 電子予定表の有効化
  SCHEDULE_COSMO_YOTSUKAICHI: 18, // 予定表（作業単位／件名単位）：コスモ四日市対応
  PLOTMAP_OBJECT_TRANSPARENT: 19, // 重機：アイコン濃淡の時間による遷移
} as const;

export type ConstructionExtensionType = (typeof ExtensionType)[keyof typeof ExtensionType];

export type ConstructionExtension = {
  extension_type: ConstructionExtensionType;
  config: ConstructionExtensionConfig;
};

export type ConstructionExtensionConfig = {
  schedule?: {
    edit_end_days: string;
    edit_end_time: string;
    schedule_date_switch_time: string;
    history_alert_time: string;
  };
};
